var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDevs = function SvgDevs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6705 1.76005H2.32954C1.81561 1.76005 1.46 2.15276 1.46 2.56331V13.4368C1.46 13.8473 1.81561 14.24 2.32954 14.24H14.6705C15.1844 14.24 15.54 13.8473 15.54 13.4368V2.56331C15.54 2.15276 15.1844 1.76005 14.6705 1.76005ZM2.32954 0.800049H14.6705C15.6809 0.800049 16.5 1.58949 16.5 2.56331V13.4368C16.5 14.4106 15.6809 15.2 14.6705 15.2H2.32954C1.31911 15.2 0.5 14.4106 0.5 13.4368V2.56331C0.5 1.58949 1.31911 0.800049 2.32954 0.800049Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4456 4.00011H1.55759C1.18159 4.00011 0.933594 3.79211 0.933594 3.50411C0.933594 3.21611 1.18159 3.01611 1.55759 3.01611H15.4456C15.8216 3.01611 16.0696 3.20811 16.0696 3.50411C16.0696 3.80011 15.8216 4.00011 15.4456 4.00011Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23943 6.06051C7.42688 6.24796 7.42688 6.55188 7.23943 6.73933L5.17884 8.79992L7.23943 10.8605C7.42688 11.048 7.42688 11.3519 7.23943 11.5393C7.05198 11.7268 6.74806 11.7268 6.56061 11.5393L4.16061 9.13933C3.97316 8.95188 3.97316 8.64796 4.16061 8.46051L6.56061 6.06051C6.74806 5.87306 7.05198 5.87306 7.23943 6.06051Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.76057 6.06051C9.57312 6.24796 9.57312 6.55188 9.76057 6.73933L11.8212 8.79992L9.76057 10.8605C9.57312 11.048 9.57312 11.3519 9.76057 11.5393C9.94802 11.7268 10.2519 11.7268 10.4394 11.5393L12.8394 9.13933C13.0268 8.95188 13.0268 8.64796 12.8394 8.46051L10.4394 6.06051C10.2519 5.87306 9.94802 5.87306 9.76057 6.06051Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devs.98ae3279.svg";
export { ForwardRef as ReactComponent };